<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled" :style="{'min-height': '400px'}">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="图形名称" prop="topoName">
              <a-input placeholder="请输入图形名称" v-model="model.topoName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供水流域" prop="processId">
              <j-dict-select-tag
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                type="list"
                v-model="model.processId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否主画面" prop="isMain">
              <j-dict-select-tag dictCode="yn" type="radioButton" v-model="model.isMain" />
              <!-- <j-dict-select-tag dictCode="yn" type="radioButton" v-model="model.readonly" /> -->
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'TopoGraphForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          topoName: [
            { required: true, message: '请输入图形名称!' },
          ],
        },
        url: {
          add: "/topo/topoGraph/add",
          edit: "/topo/topoGraph/edit",
          copy: "/topo/topoGraph/copy",
          queryById: "/topo/topoGraph/queryById"
        },
        isCopy: false,
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      copy (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        this.isCopy = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            let params = {};
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
              params = that.model;
            } else {
              if (this.isCopy) {
                httpurl += this.url.copy;
                method = 'post';
                let data = {};
                data.originId = that.model.id;
                data.processId = that.model.processId;
                data.topoName = that.model.topoName;
                params = 'originId=' + that.model.id + '&processId=' + that.model.processId + '&topoName=' + that.model.topoName + '&isMain=' + that.model.isMain;
                //that.model.originId=that.model.id;
              } else {
                httpurl += this.url.edit;
                method = 'put';
                params = that.model;
              }
            }
            this.isCopy = false;
            httpAction(httpurl, params, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>